import { useTranslation } from 'react-i18next';

/**
 * Upload progress for admin image uploads. `state` is
 * { pct, preparing } — null/undefined renders nothing.
 */
export const UploadProgress = ({ state, testId = 'upload-progress' }) => {
    const { t } = useTranslation();
    if (!state) return null;
    const pct = state.preparing ? 12 : Math.max(4, state.pct || 0);
    return (
        <div className="space-y-1 pt-1" data-testid={testId}>
            <div className="flex items-center justify-between text-[11px] text-muted-foreground">
                <span data-testid={`${testId}-label`}>
                    {state.preparing ? t('uploads.preparing') : t('uploads.uploading')}
                </span>
                {!state.preparing && (
                    <span className="tabular-nums font-semibold" data-testid={`${testId}-pct`}>{state.pct || 0}%</span>
                )}
            </div>
            <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
                <div
                    className={`h-full rounded-full bg-fuchsia-500 transition-[width] duration-200 ${state.preparing ? 'animate-pulse' : ''}`}
                    style={{ width: `${pct}%` }}
                    data-testid={`${testId}-bar`}
                />
            </div>
        </div>
    );
};
